import { log } from './log';
export const getErrorMessage = (error, fallback = 'Something went wrong...') => {
    let message;
    if (error instanceof Error) {
        message = error.message;
    }
    else if (error && typeof error === 'object' && 'message' in error) {
        message = String(error.message);
    }
    else if (typeof error === 'string') {
        message = error;
    }
    else {
        message = fallback;
    }
    return message;
};
export const handleError = (name, error) => {
    log.error(name, getErrorMessage(error));
};
//# sourceMappingURL=error.js.map